import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { FoodTypesDto } from "./food-type.dto";

export class FoodTypeResponse extends GlobalResponseObject{

      data?: FoodTypesDto;
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, intlCode:number, internalMessage:string, data?: FoodTypesDto){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.internalMessage = internalMessage;
        this.intlCode = intlCode;
        this.data = data;
    }

}